import React from 'react';
import { withFormsy } from 'formsy-react';

class FormsyCheckbox extends React.Component {
  render = () => {
    const {
      className = 'checkbox--small',
      checked,
      name,
      placeholder
    } = this.props; // ='checkbox--small'
    const inputProps = {
      name,
      checked,
      type: 'checkbox',
      onChange: this.handleChange
    };

    let classes = ['checkbox-wrap', className].join(' '); //className ? `checkbox-wrap ${className}` : 'checkbox-wrap checkbox--small';

    return (
      <div className={classes}>
        <input
          className="checkbox"
          type="checkbox"
          id={`opt_${name}`}
          checked={checked}
          {...inputProps}
        />
        <label className="checkbox-label" htmlFor={`opt_${name}`}>
          {placeholder}
        </label>
        {this.renderCheckbox(classes, name)}
      </div>
    );
  };

  handleChange = e => {
    if ('onChange' in this.props) this.props.onChange(e);
    if ('setValue' in this.props)
      this.props.setValue(
        e.currentTarget[this.props.type === 'checkbox' ? 'checked' : 'value']
      );
  };

  renderCheckbox(classes, name) {
    if (classes.includes('checkbox--small'))
      return (
        <label className="checkbox-box" htmlFor={`opt_${name}`}>
          <div className="checkbox-check">
            <svg
              className="icon icon-check"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 85.9 65.25"
            >
              <title>Checkmark</title>
              <path d="M81.28,4.59a9.08,9.08,0,0,1,3,6.11c.12,2.24-1.09,4.59-3.59,7.09L38.4,60a4.48,4.48,0,0,1-.55.49,2.32,2.32,0,0,1-.37.37,17.31,17.31,0,0,1-1.78,1.38s-.06,0-.06.06a7.41,7.41,0,0,1-1.75.83,6.24,6.24,0,0,1-1.72.4,7.65,7.65,0,0,1-.83,0A8,8,0,0,1,26.89,62a1.43,1.43,0,0,1-.37-.26,4.61,4.61,0,0,1-1-.83,3,3,0,0,1-.46-.4L5.28,40.75Q1.53,37,1.66,33.69a9,9,0,0,1,2.93-6.08,9.25,9.25,0,0,1,6.14-3q3.32-.13,7.06,3.62L31.48,41.93,68.13,5.28q3.75-3.75,7.06-3.62A8.9,8.9,0,0,1,81.28,4.59Z" />
            </svg>
          </div>
        </label>
      );
  }
}

export default withFormsy(FormsyCheckbox);



// WEBPACK FOOTER //
// ./src/components/form/FormsyCheckbox.js